import { configVars } from 'src/helpers/configVars';

export const getPropertySettingsLink = (propertyId?: string): string | null => {
  if (!propertyId) return null;
  return `${configVars.settings_service_url}/properties/${encodeURIComponent(propertyId)}/settings`;
};
